import { styled } from '@prose-ui/legacy';

const Root = styled.div`
  width: 100%;
  height: 2px;

  background-color: black;
`;

export const LineSeparator = () => <Root />;
